export enum FileStatusDisplayIdEnum {
  AVAILABLE = "available",
  PROCESSING = "processing",
  QUARANTINED = "quarantined",
  ERROR = "error",
}

export const FileDisplayIdToFileTypeMap: Record<
  FileStatusDisplayIdEnum,
  UploadStatus
> = {
  [FileStatusDisplayIdEnum.AVAILABLE]: "success",
  [FileStatusDisplayIdEnum.PROCESSING]: "uploading",
  [FileStatusDisplayIdEnum.QUARANTINED]: "error",
  [FileStatusDisplayIdEnum.ERROR]: "error",
}
